var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRemove = function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.426 6.002.114 11.35A.382.382 0 0 0 .381 12a.374.374 0 0 0 .267-.111L6 6.499l5.352 5.39a.375.375 0 0 0 .534 0 .382.382 0 0 0 0-.538L6.574 6 11.89.65a.382.382 0 0 0 0-.538.376.376 0 0 0-.534 0L6 5.504.645.111a.376.376 0 0 0-.534 0 .382.382 0 0 0 0 .538l5.315 5.353Z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};
export default SvgRemove;